import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    mainBox: {
        display: "flex",
    },
    appBar: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
    },
    appBarLeftContent: {
        display: "flex",
        alignItems: "center",
        marginLeft: "20px",
    },
    brandLogo: {
        height: "54px",
        width: "auto",
        objectFit: "contain",
        display: "block",
    },
    // Matches the "MADERA" wordmark lettering used by the CBO top bar so the two surfaces read
    // as the same product. The translateY nudge lines this text up with the wordmark, which sits
    // above the logo image's vertical center.
    portalName: {
        fontFamily: '"Aldrich", "Source Sans 3", sans-serif',
        fontSize: "24px",
        fontWeight: 700,
        letterSpacing: "0.08em",
        textTransform: "uppercase",
        color: theme.palette.text.primary,
        whiteSpace: "nowrap",
        transform: "translateY(-3px)",
    },
    appBarRightContent: {
        display: "flex",
        alignItems: "center",
    },
    appBarLanguageDropdown: {
        "& label": {
            display: "none",
        },
        "& .MuiInputBase-root": {
            width: "initial !important",
            boxShadow: "none !important",
            marginBottom: 0,
            backgroundColor: `transparent !important`,
        },
        "& .MuiSelect-select": {
            minWidth: "90px !important",
        },
        "& .MuiBox-root": {
            color: `${theme.palette.menu.icons.main} !important`,
        },
        "& .MuiSvgIcon-root": {
            color: `${theme.palette.menu.icons.main} !important`,
            width: `16px !important`,
            height: `16px !important`,
            top: `calc(50% - 0.3em) !important`,
        },
        " & fieldset": {
            border: "none !important",
        },
    },
    avatar: {
        width: `27.5px !important`,
        height: `27.5px !important`,
    },
    menuButton: {
        display: "flex !important",
        gap: "16px !important",
        fontSize: "14px !important",
        fontWeight: `400 !important`,
        fontFamily: "Source Sans 3 !important",
        color: `${theme.palette.menu.icons.main} !important`,
        textTransform: "none !important" as "none",
        "&:hover": {
            backgroundColor: "initial !important",
        },
    },
    expandMoreIcon: {
        width: `16px !important`,
        height: `16px !important`,
    },
    expandMoreIconRotated: {
        width: `16px !important`,
        height: `16px !important`,
        transform: "rotate(180deg) !important",
    },
    divider: {
        borderColor: `${theme.palette.border.divider} !important`,
        marginLeft: "12px !important",
        marginRight: "12px !important",
    },
}));

export const paperProps = {
    elevation: 0,
    sx: {
        overflow: "visible",
        filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
        mt: 1.5,
        "& .MuiAvatar-root": {
            width: 32,
            height: 32,
            ml: -0.5,
            mr: 1,
        },
    },
};
